import { Link, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, Server, AlertCircle, Wrench, ArrowLeft, LogOut } from 'lucide-react';
import { useAuth } from '../auth/AuthProvider';
import { UnlimitIcon, UnlimitWordmark } from '../components/UnlimitLogo';

export default function AdminLayout() {
  const location = useLocation();
  const { userName, logout } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/console', icon: LayoutDashboard },
    { name: 'Components', href: '/console/components', icon: Server },
    { name: 'Incidents', href: '/console/incidents', icon: AlertCircle },
    { name: 'Maintenances', href: '/console/maintenances', icon: Wrench },
  ];

  return (
    <div className="min-h-screen bg-unlimit-gray-light">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-navy-900 min-h-screen flex flex-col">
          <div className="p-6">
            <Link to="/" className="flex items-center space-x-2.5 group">
              <UnlimitIcon size={32} className="group-hover:scale-105 transition-transform" />
              <div>
                <UnlimitWordmark className="h-3.5 text-white" />
                <span className="block text-[10px] text-gray-500 -mt-0.5 uppercase tracking-widest">Admin</span>
              </div>
            </Link>
          </div>
          <nav className="mt-4 px-3 flex-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center space-x-2.5 px-3.5 py-2.5 mb-1 text-sm font-medium rounded-lg transition-all duration-150 ${
                    isActive
                      ? 'bg-unlimit-lime text-navy-900 shadow-sm'
                      : 'text-gray-400 hover:bg-white/5 hover:text-white'
                  }`}
                >
                  <item.icon className="h-4 w-4" />
                  <span>{item.name}</span>
                </Link>
              );
            })}
          </nav>

          <div className="p-3 mt-auto">
            <Link
              to="/"
              className="flex items-center space-x-2 px-3.5 py-2.5 text-xs text-gray-500 hover:text-unlimit-lime transition-colors rounded-lg hover:bg-white/5"
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              <span>Back to Status Page</span>
            </Link>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1">
          <div className="bg-white border-b border-gray-100">
            <div className="px-8 py-4 flex justify-between items-center">
              <div>
                <h1 className="text-lg font-bold text-navy-900">Admin Panel</h1>
                <p className="text-xs text-gray-400 mt-0.5">Manage your status page and services</p>
              </div>
              <div className="flex items-center space-x-3">
                {userName && (
                  <span className="text-xs text-gray-500 bg-unlimit-gray-light px-3 py-1.5 rounded-md">{userName}</span>
                )}
                <button
                  onClick={logout}
                  className="flex items-center space-x-1.5 px-3 py-1.5 text-xs text-gray-400 hover:text-rose-400 hover:bg-rose-50 rounded-md transition-colors"
                  title="Logout"
                >
                  <LogOut className="h-3.5 w-3.5" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
          <div className="p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
